const ERROR_CODE = {
    ERR_NETWORK: "ERR_NETWORK",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    NOT_FOUND: "NOT_FOUND",
    SERVER_ERROR: "SERVER_ERROR",
    BAD_REQUEST: "BAD_REQUEST",
    VALIDATION_ERROR: "VALIDATION_ERROR",
    UNKNOWN: "UNKNOWN",
} as const;

export default ERROR_CODE;